import TabMaster from "#core/components/tab/TabMaster"
import { MyEvaluationsItems } from "#performance-evaluation/components/MyEvaluations/MyEvaluationsItems"
import { Box } from "@mui/system"
import { ChangeTitle } from "Components/menu/funciones"
import { useState } from "react"
import { useParams } from "react-router-dom"
import ActionPlan from "./ActionPlan"

export default function MyEvaluations() {
	ChangeTitle("mis Evaluaciones ")

	const [tab, setTab] = useState("Evaluaciones")
	const paramsUrl = useParams()
	const collaboratorId = paramsUrl["collaboratorId"]
	// const [reload, setReload] = useState(false)

	const listTabs = [
		{
			id: "Evaluaciones",
			// label: "Competencias",
			content: <MyEvaluationsItems collaboratorId={collaboratorId} />,
		},
		{
			id: "Plan de Acción",
			// label: "KPI'S",
			content: <ActionPlan collaboratorId={collaboratorId} reload />,
		},
	]

	return (
		<Box>
			<TabMaster listTabs={listTabs} selectedTab={tab} setSelectedTab={setTab} />
		</Box>
	)
}
